import {Component, ElementRef, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {IonContent, NavController, PopoverController} from '@ionic/angular';
import {NativeAudio} from "@capgo/native-audio";
import {PostModel} from 'src/app/models/post.model';
import {UserModel} from 'src/app/models/user.model';
import {GlobalService} from 'src/app/services/global/global.service';
import {PostService} from 'src/app/services/post/post.service';
import {ApiResponse} from 'src/app/services/utils';
import {StorageService} from '../../services/storage/storage.service';
import {UserService} from '../../services/user/user.service';
import {AuthService} from '../../services/auth/auth.service';

@Component({
    selector: 'app-comments',
    templateUrl: './comments.component.html',
    styleUrls: ['./comments.component.scss'],
    standalone: false
})
export class CommentsComponent implements OnInit {
  @Input() content: IonContent;
  @Input() commentInput: ElementRef<HTMLTextAreaElement>;
  @Input() item: PostModel;
  @Input() user: UserModel;
  @Input() detailPage;
  @Input() commentScrollTop;
  @Input() commentBox;

  @Output() commentBoxEvent = new EventEmitter<any>();

  commentType = 'new';
  comments = [];
  contentY = 0;
  parentId = 0;
  pagination = 1;
  checkCounter = 0;

  translateCommentFlag = [] as any;
  translateComment = [] as any;
  commentResponseFlag = false;
  noMoreComments: boolean = false;

  constructor(
    private postService: PostService,
    private navController: NavController,
    public globalService: GlobalService,
    private auth: AuthService,
    private storage: StorageService,
    private userService: UserService,
    private popoverCtrl: PopoverController
  ) {
  }

  ngOnInit() {
    if (this.detailPage === 'yes') {
      this.loadInitialComments(3);
    }
  }

  commentSubmit(commentForm: UntypedFormGroup, userSelectedTags: any) {
    if (this.user && this.auth.isAuthenticated) {
      if (this.commentType === 'new') {
        const data = {
          userTags: userSelectedTags,
          comment: commentForm.value.comment,
          postId: this.item?.id
        };

        this.postService.apiAddCommentPost(data).subscribe((result: ApiResponse) => {
          if (result.status) {
            this.item = result.data;
            commentForm.reset();
            this.loadComments(this.item);
            if (this.commentInput?.nativeElement) {
              this.commentInput.nativeElement.style.borderColor = 'var(--ion-color-tertiary-opacity)';
            }
          }
        });
      } else if (this.commentType === 'edit') {
        const data = {
          comment: commentForm.value.comment,
          commentId: commentForm.value.commentId
        };
        this.postService.apiEditCommentPost(data).subscribe((result: ApiResponse) => {
          if (result.status) {
            commentForm.reset();
            this.loadComments(this.item);
            if (this.detailPage === 'no') {
              alert('comment edited');
              this.commentInput.nativeElement.style.borderColor = '#6E6E6E80';
            }
          }
        });
      } else if (this.commentType === 'reply') {

        const data: any = {
          comment: commentForm.value.comment,
          commentId: commentForm.value.commentId,
          postId: this.item?.id
        };
        if (this.parentId !== 0) {
          data.parentId = this.parentId;
        }
        this.postService.apiAddCommentPost(data).subscribe((result: ApiResponse) => {
          if (result.status) {
            commentForm.reset();
            this.loadComments(this.item);
          }
        });
      }
      this.commentType = 'new';
      this.parentId = 0;
    } else {
      this.globalService.openLoginModal();
    }
  }

  editComment(comment) {
    if (this.detailPage === 'no') {
      this.commentInput.nativeElement.scrollIntoView({behavior: 'smooth', block: 'start'});
      this.commentInput.nativeElement.style.borderColor = '#FF8E14';
    }
    const data = {
      comment: comment.comment,
      commentId: comment.id
    };
    this.commentType = 'edit';
    this.commentBoxEvent.emit({val: data, behavior: {behavior: 'smooth', block: 'start'}, borderColor: '#FF8E14'});
    if (this.detailPage === 'no') {
      this.commentInput.nativeElement.focus();
    }
  }

  replyCommentFun(comment, parentId) {
    if (this.detailPage === 'no') {
      this.commentInput.nativeElement.scrollIntoView({behavior: 'smooth', block: 'start'});
      this.commentInput.nativeElement.style.borderColor = '#FF8E14';
    }
    const data = {
      comment: '',
      commentId: comment.id
    };
    this.commentType = 'reply';
    this.commentBoxEvent.emit({val: data, behavior: {behavior: 'smooth', block: 'start'}, borderColor: '#FF8E14'});
    if (this.detailPage === 'no') {
      this.commentInput.nativeElement.focus();
    }
    this.parentId = parentId;
  }

  likeComment(comment) {
    if (this.user && this.auth.isAuthenticated) {
      this.postService.likeActionComment(comment.id).subscribe(async (result: any) => {
        if (result.status) {
          this.globalService.presentToast(result.message);
          this.loadComments(this.item);
          if (result.message === 'Comment Liked' && await this.storage.isInteractionSoundOn()) {
            NativeAudio.play({
              assetId: 'like',
              time: 0
            });
          }
        }
      });
    } else {
      this.isAnonymousAction();
    }
  }

  clickTranslateComment(item) {
    if (!this.translateCommentFlag[item.id]) {
      this.postService.apiTranslateComment(item.id).subscribe((result: any) => {
        if (result.status) {
          this.translateCommentFlag[item.id] = !this.translateCommentFlag[item.id];
          this.translateComment[item.id] = result.data.commentTranslations.comment;
        }
      });
    } else {
      this.translateCommentFlag[item.id] = !this.translateCommentFlag[item.id];
    }
  }

  async scrollToTopOnInit() {
    await this.content.scrollToTop(300);
  }

  async openOtherProfile(id) {
    if (this.user && this.auth.isAuthenticated) {
      if (this.user && this.user.id === id) {
        await this.navController.navigateForward(['app/profile']);
      } else {
        await this.navController.navigateForward(['app/home/other-profile/' + id]);
      }
    } else {
      this.isAnonymousAction();
    }
  }

  loadCommentByComponent() {
    // this.commentBox = !this.commentBox;
    this.loadComments(this.item);
  }

  loadComments(item) {
    this.postService.apiGetComments(item.id, 1).subscribe((result: ApiResponse) => {
      if (result.status) {
        this.comments = result.data.data;
        this.pagination++;
      }
    });
  }

  loadInitialComments(pagesToLoad: number = 3) {
    const loadNext = () => {
      if (this.pagination < pagesToLoad && !this.noMoreComments) {
        this.commentResponseFlag = true;

        this.postService.apiGetComments(this.item.id, this.pagination).subscribe((result: ApiResponse) => {
          if (result.status && result.data.data.length > 0) {
            this.pagination++;
            this.comments.push(...result.data.data);
          } else {
            this.noMoreComments = true;
          }

          this.commentResponseFlag = false;
          loadNext();
        });
      }
    };

    loadNext();
  }


  loadMoreComments(event) {
    if (this.commentResponseFlag || this.noMoreComments) {
      event.target.complete();
      return;
    }

    this.commentResponseFlag = true;

    let loadCount = 0;
    const maxLoads = 3;

    const loadNext = () => {
      if (loadCount < maxLoads && !this.noMoreComments) {
        this.postService.apiGetComments(this.item.id, this.pagination).subscribe((result: ApiResponse) => {
          if (result.status && result.data.data.length > 0) {
            this.pagination++;
            this.comments.push(...result.data.data);
          } else {
            this.noMoreComments = true;
          }

          loadCount++;
          if (loadCount < maxLoads && !this.noMoreComments) {
            loadNext();
          } else {
            this.commentResponseFlag = false;
            event.target.complete();
          }
        });
      }
    };

    loadNext();
  }



  getContent(comment: any) {
    let str = comment.comment;
    let counter = 0;
    const arrToReturn = [];

    comment.userTag.forEach((element, index) => {
      const q = '@' + element.username;
      if (str.indexOf(q) !== -1) {
        const startIndex = str.indexOf(q);
        const endIndex = startIndex + q.length;
        if (str.indexOf(q) === 0) {
          arrToReturn.push(counter);
          str = str.substring(endIndex, str.length);
        } else {
          arrToReturn.push(str.substring(0, startIndex));
          arrToReturn.push(counter);
          str = str.substring(endIndex, str.length);
        }
      }
      if (str.length > 0 && index + 1 === comment.userTag.length) {
        arrToReturn.push(str);
      }
      counter++;
    });


    if (arrToReturn.length !== 0) {
      return arrToReturn;
    } else {
      arrToReturn.push(str);
      return arrToReturn;
    }
  }

  checkIsString(txt) {
    return typeof txt === 'string';
  }

  reportComment(id) {
    this.popoverCtrl.dismiss();
    this.postService.apiReportComment(id).subscribe((result: ApiResponse) => {
      if (result.status) {
        this.globalService.presentToast(result.message);
      }
    });
  }

  /*  hideComment(id) {
      this.popoverCtrl.dismiss();
     this.postService.apiHideComment(id).subscribe((result: ApiResponse) => {
        if (result.status) {
          const indexOfComment = this.comments.indexOf( (comment: any) => comment.id === id );
          this.comments.splice(indexOfComment, 1);
          this.globalService.presentToast(result.message);
        }
      });
    }*/

  blockUser(id) {
    this.popoverCtrl.dismiss();
    this.userService.apiBlockUser(id).subscribe((result: ApiResponse) => {
      if (result.status) {
        this.auth.userLoggedIn.next('hardreload');
        this.globalService.presentToast(result.message);
      }
    });
  }

  /*  deleteComment(item){
      this.popoverCtrl.dismiss();
    }*/

  isAnonymousAction() {
    if (!(this.user && this.auth.isAuthenticated)) {
      this.globalService.openLoginModal();
    }
  }
}
